import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import {
  getUsages,
  getUsagesBeV2,
  getUsagesForAddressBeV2,
  getServiceProductInsightsForCustomer,
  enableServiceProductInsightsForCustomer,
  disableServiceProductInsightsForCustomer,
  getServiceProductIsmaForCustomer,
  disableServiceProductIsmaForCustomer,
  enableServiceProductIsmaForCustomer,
  getMonthlyEnergyReportDocumentsByCustomer,
  getShortUrlAndExternalMandate,
  getShortUrlAndExternalMandateV2,
  getInsightsDashboard,
  getInsightsDashboardForAddress,
  getCaptarUsages,
  getCaptarDetails,
  getSolarForecastUsages,
  getSolarForecastUsagesForAddress,
} from '../services/UsagesService';

export const useUsagesGetUsages = createDCHook(
  'getUsages',
  collapseDataFromCall(getUsages),
  { injectables: ['label', 'customerId', 'accountId'], flattenData: true },
  { maxAge: 60000 },
);

export const useUsagesGetUsagesBeV2 = createDCHook(
  'getUsagesBeV2',
  collapseDataFromCall(getUsagesBeV2),
  { injectables: ['label', 'customerId', 'accountId'], flattenData: true },
  { maxAge: 60000 },
);

export const useUsagesGetUsagesForAddressBeV2 = createDCHook(
  'getUsagesForAddressBeV2',
  collapseDataFromCall(getUsagesForAddressBeV2),
  { injectables: ['label', 'customerId', 'accountId'], flattenData: true },
);

export const useUsagesGetServiceProductInsightsForCustomer = createDCHook(
  'getServiceProductInsightsForCustomer',
  collapseDataFromCall(getServiceProductInsightsForCustomer),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
  { maxAge: 15000 },
);

export const useUsagesEnableServiceProductInsightsForCustomer = createMutationHook(
  enableServiceProductInsightsForCustomer,
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: false },
);

export const useUsagesDisableServiceProductInsightsForCustomer = createMutationHook(
  disableServiceProductInsightsForCustomer,
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: false },
);

export const useUsagesGetServiceProductIsmaForCustomer = createDCHook(
  'getServiceProductIsmaForCustomer',
  collapseDataFromCall(getServiceProductIsmaForCustomer),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
  { maxAge: 15000 },
);

export const useUsagesDisableServiceProductIsmaForCustomer = createMutationHook(disableServiceProductIsmaForCustomer, {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: false,
});

export const useUsagesEnableServiceProductIsmaForCustomer = createMutationHook(
  collapseDataFromCall(enableServiceProductIsmaForCustomer),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useUsagesGetMonthlyEnergyReportDocumentsByCustomer = createDCHook(
  'getMonthlyEnergyReportDocumentsByCustomer',
  collapseDataFromCall(getMonthlyEnergyReportDocumentsByCustomer),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useUsagesGetShortUrlAndExternalMandate = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(getShortUrlAndExternalMandate, 'requestBody', 'data'),
      'data',
      'returnUrlSuccess',
      'returnUrlFailed',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'accountId'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['returnUrlSuccess', 'returnUrlFailed'] },
    ],
  },
);

export const useUsagesGetShortUrlAndExternalMandateV2 = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(getShortUrlAndExternalMandateV2, 'requestBody', 'data'),
      'data',
      'returnUrlSuccess',
      'returnUrlFailed',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['returnUrlSuccess', 'returnUrlFailed'] },
    ],
  },
);

export const useUsagesGetInsightsDashboard = createDCHook(
  'getInsightsDashboard',
  collapseDataFromCall(getInsightsDashboard),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
  { maxAge: 15000 },
);

export const useUsagesGetInsightsDashboardForAddress = createDCHook(
  'getInsightsDashboardForAddress',
  collapseDataFromCall(getInsightsDashboardForAddress),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useUsagesGetCaptarUsages = createDCHook('getCaptarUsages', collapseDataFromCall(getCaptarUsages), {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: true,
});

export const useUsagesGetCaptarDetails = createDCHook('getCaptarDetails', collapseDataFromCall(getCaptarDetails), {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: true,
});

export const useUsagesGetSolarForecastUsages = createDCHook(
  'getSolarForecastUsages',
  collapseDataFromCall(getSolarForecastUsages),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
  { maxAge: 300000 },
);

export const useUsagesGetSolarForecastUsagesForAddress = createDCHook(
  'getSolarForecastUsagesForAddress',
  collapseDataFromCall(getSolarForecastUsagesForAddress),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);
